import { getStartEndDateOfSameDay } from './../../../../../../../../../utils/date-time-utility';
import { useState, useCallback, useEffect } from "react";
import dayjs, { Dayjs } from "dayjs";

export type FilterType = "day" | "week" | "month" | "year";

const getWeekRange = (date: Dayjs) => ({
  from: date.startOf("week"),
  to: date.endOf("week"),
});
const getMonthRange = (date: Dayjs) => ({
  from: date.startOf("month"),
  to: date.endOf("month"),
});
const getYearRange = (date: Dayjs) => ({
  from: date.startOf("year"),
  to: date.endOf("year"),
});

export interface UseAssessmentDateFilterResult {
  filter: FilterType;
  setFilter: React.Dispatch<React.SetStateAction<FilterType>>;
  selectedDate: Dayjs;
  setSelectedDate: React.Dispatch<React.SetStateAction<Dayjs>>;
  range: { from: Dayjs; to: Dayjs };
  handleChange: (date: Dayjs) => void;
}

export function useAssessmentDateFilter(
  initialFilter: FilterType = "day",
  initialDate: Dayjs = dayjs(),
  onChange?: (obj: { filter: FilterType; from: Dayjs; to: Dayjs }) => void
): UseAssessmentDateFilterResult {
  const [filter, setFilter] = useState<FilterType>(initialFilter);
  const [selectedDate, setSelectedDate] = useState<Dayjs>(initialDate);

  let range: { from: Dayjs; to: Dayjs };
  if (filter === "day"){
    
  const { startTime, endTime } = getStartEndDateOfSameDay(selectedDate);
    range = { from: startTime ? dayjs(startTime) : dayjs(), to: endTime ? dayjs(endTime) : dayjs() }
  }
  else if (filter === "week") range = getWeekRange(selectedDate);
  else if (filter === "month") range = getMonthRange(selectedDate);
  else range = getYearRange(selectedDate);

  const handleChange = useCallback((date: Dayjs) => {
    setSelectedDate(date);
  }, []);

  useEffect(() => {
    if (onChange) {
      onChange({ filter, ...range });
    }
  }, [filter, selectedDate]);

  return {
    filter,
    setFilter,
    selectedDate,
    setSelectedDate,
    range,
    handleChange,
  };
}
